// pages/Home.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropertyCard from '../components/PropertyCard';
import './Home.css';

// Iconos para el buscador
const SearchIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
  </svg>
);

const LocationIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
  </svg>
);

const PriceIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.78-1.18 2.73-3.12 3.16z"/>
  </svg>
);

const Home = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [searchType, setSearchType] = useState('ciudad'); // ciudad, nombre, precio
  const [suggestions, setSuggestions] = useState([]);

  // Datos reales de los 3 apartamentos
  const featuredProperties = [
    {
      id: 'apartamento-401',
      title: 'Apartamento 401',
      location: 'Barranquilla, Atlántico',
      price: '$480.000.000',
      alquiler: '$4.300.000',
      type: 'Venta / Alquiler',
      bedrooms: 1,
      bathrooms: 1,
      area: '50 m²',
      image: '/images/401/1.jpeg',
      description: 'Apartamento 401 de 50 metros cuadrados con sala comedor, cocina, área de labor aparte, cuarto, baño y clóset. Completamente amoblado con servicios al día, internet y cable.'
    },
    {
      id: 'apartamento-602',
      title: 'Apartamento 602',
      location: 'Barranquilla, Atlántico',
      price: '$380.000.000',
      alquiler: '$3.500.000',
      type: 'Venta / Alquiler',
      bedrooms: 1,
      bathrooms: 1,
      area: '41 m²',
      image: '/images/602/1.jpeg',
      description: 'Apartamento 602 de 41 metros cuadrados con sala, cocina, pequeño espacio para área de labor, cuarto, baño y clóset. Completamente amoblado con servicios al día, internet y cable.'
    },
    {
      id: 'apartamento-702',
      title: 'Apartamento 702',
      location: 'Barranquilla, Atlántico',
      price: '$380.000.000',
      alquiler: '$3.500.000',
      type: 'Venta / Alquiler',
      bedrooms: 1,
      bathrooms: 1,
      area: '41 m²',
      image: '/images/702/1.jpeg',
      description: 'Apartamento 702 de 41 metros cuadrados con sala, cocina, pequeño espacio para área de labor, cuarto, baño y clóset. Completamente amoblado con servicios al día, internet y cable.'
    }
    ,
    {
      id: 'apartamento-303',
      title: 'Apartamento 303',
      location: 'Barranquilla, Atlántico',
      price: '$1.500.000.000',
      type: 'Venta',
      bedrooms: 3,
      bathrooms: 3,
      area: '163.31 m²',
      image: '/images/702/1.jpeg',
      description: 'Apartamento 303 de 163.31 metros cuadrados con sala, cocina, pequeño espacio para área de labor, cuarto, baño y clóset. Completamente amoblado con servicios al día, internet y cable.'
    }
    ,
    {
      id: 'apartamento-403',
      title: 'Apartamento 403',
      location: 'Barranquilla, Atlántico',
      price: '$1.500.000.000',
      type: 'Venta',
      bedrooms: 3,
      bathrooms: 3,
      area: '163.31 m²',
      image: '/images/702/1.jpeg',
      description: 'Apartamento 403 de 163.31 metros cuadrados con sala, cocina, pequeño espacio para área de labor, cuarto, baño y clóset. Completamente amoblado con servicios al día, internet y cable.'
    }
  ];

  // Ciudades disponibles para sugerencias
  const cities = ['Barranquilla', 'Cartagena', 'Bogotá', 'Medellín', 'Cali', 'Santa Marta'];
  const propertyNames = ['Apartamento 401', 'Apartamento 602', 'Apartamento 702', 'Apartamento 303', 'Apartamento 403'];
  const priceRanges = ['$300,000 - $380,000', '$400,000 - $500,000', '$1.000,000+'];

  const handleSearch = (e) => {
    if (e) e.preventDefault();
    
    if (searchTerm.trim()) {
      // Navegar a la página de búsqueda con los parámetros
      navigate(`/search?q=${encodeURIComponent(searchTerm)}&type=${searchType}`);
    }
  };

  const handleInputChange = (value) => {
    setSearchTerm(value);
    
    if (value.trim()) {
      let filteredSuggestions = [];
      
      switch (searchType) {
        case 'ciudad':
          filteredSuggestions = cities.filter(city =>
            city.toLowerCase().includes(value.toLowerCase())
          );
          break;
        case 'nombre':
          filteredSuggestions = propertyNames.filter(name =>
            name.toLowerCase().includes(value.toLowerCase())
          );
          break;
        case 'precio':
          filteredSuggestions = priceRanges.filter(price =>
            price.toLowerCase().includes(value.toLowerCase())
          );
          break;
        default:
          filteredSuggestions = [];
      }
      
      setSuggestions(filteredSuggestions.slice(0, 5));
    } else {
      setSuggestions([]);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setSearchTerm(suggestion);
    setSuggestions([]);
  };

  const getPlaceholder = () => {
    switch (searchType) {
      case 'ciudad':
        return 'Ej: Barranquilla, Cartagena...';
      case 'nombre':
        return 'Ej: Apartamento 401...';
      case 'precio':
        return 'Ej: $80,000 - $90,000...';
      default:
        return 'Buscar propiedades...';
    }
  };

  return (
    <div className="home">
      {/* Hero Section con Buscador */}
      <section className="hero">
        <div className="hero-content">
          <h1>Encuentra tu propiedad ideal</h1>
          <p>Descubre los mejores apartamentos en Barranquilla</p>
          
          {/* Buscador */}
          <div className="search-container">
            <form onSubmit={handleSearch} className="search-form">
              <div className="search-filters">
                <button 
                  type="button"
                  className={`filter-btn ${searchType === 'ciudad' ? 'active' : ''}`}
                  onClick={() => setSearchType('ciudad')}
                >
                  <LocationIcon />
                  Ciudad
                </button>
                <button 
                  type="button"
                  className={`filter-btn ${searchType === 'nombre' ? 'active' : ''}`}
                  onClick={() => setSearchType('nombre')}
                >
                  <SearchIcon />
                  Nombre
                </button>
                <button 
                  type="button"
                  className={`filter-btn ${searchType === 'precio' ? 'active' : ''}`}
                  onClick={() => setSearchType('precio')}
                >
                  <PriceIcon />
                  Precio
                </button>
              </div>
              
              <div className="search-input-container">
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => handleInputChange(e.target.value)}
                  placeholder={getPlaceholder()}
                  className="search-input"
                />
                <button type="submit" className="search-submit">
                  <SearchIcon />
                  Buscar
                </button>
                
                {/* Sugerencias */}
                {suggestions.length > 0 && (
                  <div className="suggestions-dropdown">
                    {suggestions.map((suggestion, index) => (
                      <div
                        key={index}
                        className="suggestion-item"
                        onClick={() => handleSuggestionClick(suggestion)}
                      >
                        {suggestion}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </form>
          </div>
          
          <div className="search-tags">
            <span>Populares:</span>
            <button onClick={() => { setSearchType('ciudad'); setSearchTerm('Barranquilla'); }}>
              Barranquilla
            </button>
            <button onClick={() => { setSearchType('precio'); setSearchTerm('$85,000'); }}>
              Desde $85,000
            </button>
            <button onClick={() => { setSearchType('nombre'); setSearchTerm('Apartamento'); }}>
              Apartamentos
            </button>
          </div>
        </div>
      </section>

      {/* Propiedades Destacadas */}
      <section className="featured-properties">
        <div className="container">
          <h2>Nuestros Apartamentos</h2>
          <p className="section-subtitle">Descubre nuestros apartamentos disponibles en el Edificio K58</p>
          <div className="properties-grid">
            {featuredProperties.map(property => (
              <PropertyCard key={property.id} property={property} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;